export default __webpack_public_path__ + "static/media/postgresql.b32a240d.png";